import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import PaymentActions from '../actions/PaymentActions';


const PaymentSource = {
    getPayments() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.paymentmethodList).fetch();
            },

            local(state) {
                // So we don't do the call again when rendering clientside
                return state.payments.length ? state : null;
            },

            success: PaymentActions.getSuccess,
            error: CurrentUserActions.pageFault
        };
    }
};

class PaymentStore {
    constructor() {
        this.payments = [];

        this.exportAsync(PaymentSource);
        this.bindActions(PaymentActions);
    }

    onGetSuccess(payments) {
        this.setState({payments})
    }
}

export default createStore(PaymentStore, 'PaymentStore', module);




/** WEBPACK FOOTER **
 ** ./app/src/stores/PaymentStore.js
 **/